module.exports = __webpack_public_path__ + "img/review-10.c768e090.png";